import { Component, Host, h , Prop, State} from '@stencil/core';

@Component({
  tag: 'lgr-phone-floating',
  styleUrl: 'lgr-phone-floating.scss',
  shadow: true,
})
export class LgrPhoneFloating {
  @Prop({ reflect: true }) startVisible: boolean = false ;

  @State() visible: boolean = this.startVisible;
  @State() isMobileOrTablet: boolean = false;

  @Prop({ reflect: true }) textIntro: string = 'Olá! Precisa de ajuda?';

  @Prop({ reflect: true }) storeNumber!: string ;

  @Prop({ reflect: true }) callToStore: string = 'Ligar para a loja';

  @Prop({ reflect: true }) whatsAppNumber!: string ;

  @Prop({ reflect: true }) whatsAppMessage!: string;

  componentWillLoad() {
    this.checkDeviceType();
    window.addEventListener('resize', this.checkDeviceType);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.checkDeviceType);
  }

  checkDeviceType = () => {
    const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isTablet = /iPad|tablet/i.test(navigator.userAgent);
    this.isMobileOrTablet = isMobile || isTablet;
  }

  render() {
    return (
      <Host>
        <div class="lgr-phone-floating-container">
          <div class="lgr-phone-floating-number-container" data-visible={this.visible ? 'true': 'false'}>
            <div class="lgr-phone-floating-close"
              onClick={() => {
                this.visible = false;
              }}
            >
            </div>
            <div class="lgr-phone-floating-number-text-intro">{this.textIntro}</div>
            
            {this.storeNumber && this.isMobileOrTablet ?
              <div class="lgr-phone-floating-number-item number-store">
                <a href={`tel:${this.storeNumber}`} target='_blank'>
                  <span>{this.callToStore}</span>
                </a>
              </div>
              : null
            }

            {this.whatsAppNumber ?
              <div class="lgr-phone-floating-number-item number-whatsapp">
                <a href={(() => {
                  if (!this.whatsAppNumber) return 'javascript:void(0)';
              
                  const phone = this.whatsAppNumber.replace(/\D/g, '');
                  const message = this.whatsAppMessage || '';
                  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
              
                  const textParam = `text=${message.replace(/ /g, '%20').replace(/\n/g, '%0A')}`;
              
                  return isMobile
                    ? `https://wa.me/${phone}?${textParam}`
                    : `https://web.whatsapp.com/send?phone=${phone}&${textParam}`;
                })()} target="_blank">
                  <span>Conversar por WhatsApp</span>
                </a>
              </div>
              : null
            }
          </div>
          <div class="lgr-phone-floating-trigger"
            onClick={() => {
              this.visible = true;
            }}
          >
          </div>
        </div>
      </Host>
    );
  }

}
